var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info.attchList[0] && _vm.info.attchList[0])?_c('div',{attrs:{"id":"picture"}},[_c('img',{attrs:{"src":_vm.url+_vm.info.attchList[0].filePath+_vm.info.attchList[0].ext,"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }